export const environment = {
  firebaseConfig: {
    projectId: 'digi-card-b1c32',
    appId: '1:284587018615:web:93a453f9a66ae47df2b972',
    storageBucket: 'digi-card-b1c32.appspot.com',
    apiKey: 'AIzaSyCX1iCp01_DAj-D3ekTj4iZ5-bw6X0rE7k',
    authDomain: 'digi-card-b1c32.firebaseapp.com',
    messagingSenderId: '284587018615',
    measurementId: 'G-YG8DBXXNB1',
  },
  production: true,
  useEmulator: false,
  ZOHO_CLIENT_ID: "1000.F86RO636DM3BM77KTTGXGJ54YZ3YJR",
  ZOHO_REDIRECT_URI: "https://silencetokencreation-f7w4n766wq-uc.a.run.app",
  HUBSPOT_CLIENT_ID: "710fcbd2-2f41-4f62-bd35-7c6d14feb2ac",
  HUBSPOT_REDIRECT_URI: "https://silencetokencreation-f7w4n766wq-uc.a.run.app",
  PIPEDRIVE_CLIENT_ID: "20ffdc63783ef183",
  PIPEDRIVE_REDIRECT_URI: "https://silencetokencreation-f7w4n766wq-uc.a.run.app",
  SALESFORCE_CLIENT_ID: "3MVG91oqviqJKoEFWG7tj9QrQ0FIPpQ7DpTpkZ7807KEsT3jKCSb0jOtfMv8wney8FyHdgkMpq3XI6UFbbdhu",
  SALESFORCE_REDIRECT_URI: "https://silencetokencreation-f7w4n766wq-uc.a.run.app",
};
